import React from 'react';
function Testimonials() {  return (
    <section>
      <div className="wrap">
        <div className="section-head center reveal">
          <div className="eyebrow">{"Testimonials"}</div>
          <h2>{"What Our Families Say"}</h2>
        </div>
        <div className="quote-strip reveal">
          <div className="quote-card">
            <div className="stars">
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
            </div>
            <p>{"The teachers give my daughter personal attention and encourage her to take part in class. We have seen her confidence grow throughout the year."}</p>
            <div className="quote-who">
              <div className="avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                  <circle cx="12" cy="8" r="4"></circle>
                  <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
                </svg>
              </div>
              <div>
                <b>{"Ayesha Malik"}</b>
                <span>{"Parent, Grade 5"}</span>
              </div>
            </div>
          </div>
          <div className="quote-card">
            <div className="stars">
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
            </div>
            <p>{"The practical studies program changed how my son approaches problems — he now looks for ways to apply what he learns."}</p>
            <div className="quote-who">
              <div className="avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                  <circle cx="12" cy="8" r="4"></circle>
                  <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
                </svg>
              </div>
              <div>
                <b>{"Taimur Ahmed"}</b>
                <span>{"Parent, Grade 8"}</span>
              </div>
            </div>
          </div>
          <div className="quote-card">
            <div className="stars">
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
              <svg viewBox="0 0 24 24">
                <path d="M12 2l3 7h7l-5.5 4.5L18.5 21 12 16.8 5.5 21l2-7.5L2 9h7z"></path>
              </svg>
            </div>
            <p>{"Small class sizes were the deciding factor for us, and three years in, it's still the reason we tell other families to visit."}</p>
            <div className="quote-who">
              <div className="avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                  <circle cx="12" cy="8" r="4"></circle>
                  <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
                </svg>
              </div>
              <div>
                <b>{"Muhammad Ali"}</b>
                <span>{"Parent, Grade 3"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
